export default __webpack_public_path__ + "static/media/icon-connect.a426ab0d.svg";